import type { Stage } from '../lib/types';
import { KanbanCard } from './kanban-card';

interface KanbanColumnProps {
  stage: Stage;
}

export function KanbanColumn({ stage }: KanbanColumnProps) {
  // Determine currency from the first deal that has it, or default
  const displayCurrency = stage.deals.find((d) => d.currency)?.currency || 'DKK';

  return (
    <div className="bg-slate-100 p-3 rounded-lg w-56 flex-shrink-0">
      <div className="mb-3">
        <h2 className="font-bold text-gray-700 text-md">{stage.title}</h2>
        <p className="text-xs text-gray-500">
          {displayCurrency} {stage.totalValue.toLocaleString('da-DK')}
          {stage.dealCount > 0 && ` - ${stage.dealCount} deal${stage.dealCount > 1 ? 's' : ''}`}
        </p>
      </div>
      <div className="space-y-3 h-[calc(100vh-200px)] overflow-y-auto pr-1">
        {stage.deals.map((deal) => (
          <KanbanCard key={deal.id} deal={deal} />
        ))}
        {stage.deals.length === 0 && (
          <div className="text-center text-sm text-gray-400 py-4">No deals in this stage.</div>
        )}
      </div>
    </div>
  );
}
